import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import {
  getAllRoutes,
  getFlightCards,
  getAircraft,
  udpateFlightCardActive,
  addFlightCard
} from '../../actions/flightCardActions';
import { FlightCard } from '../../models/flight-card.interface';
import ActivateFlightCardRouteDialog from './ActivateFlightCardRouteDialog';
import { useAppSelector } from 'hooks/redux';
import { selectCells } from 'selectors/ordersSelector';
import { getCells } from 'actions/orderActions';
import { newNotification } from 'actions/uiActions';
import FilteredDropdown from 'components/FilteredDropdown/FilteredDropdown';
import FlightCardMap from './FlightCardMap';

const ViewFlightCards = ({
  flightCards,
  getFlightCards,
  getAllRoutes,
  getAircraft,
  udpateFlightCardActive,
  addFlightCard
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedAircraft, setSelectedAircraft] = useState(null);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [selectedFlightCard, setSelectedFlightCard] = useState<FlightCard>();
  const [allAdresses, setAllAdresses] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [filteredAircraft, setFilteredAircraft] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [checked, setChecked] = useState(false);
  const cells = useAppSelector(selectCells);
  const [sortedCells, setSortedCells] = useState([]);
  const [selectedCell, setSelectedCell] = useState(null);
  const [latestFlightCards, setLatestFlightCards] = useState(flightCards);
  const [filteredFlightCards, setFilteredFlightCards] = useState([]);
  const [routeLength, setRouteLength] = useState(0);
  const [routeTooLow, setRouteTooLow] = useState(false);
  const [routeSloped, setRouteSloped] = useState(false);
  const maxRecommendedDistance = 10; // in kms
  const maxRecommendedAltitude = 30; // in metres

  const mapRef = useRef(null);
  const [mapHeight, setMapHeight] = useState(0);
  const [mapWidth, setMapWidth] = useState(0);
  const [isConflict, setIsConflict] = useState(false);
  const [isBlockConflictName, setIsBlockConflictName] = useState(false);

  const handleActiveFlightCard = (flightCard, checked) => {
    const isRouteValid = selectedRoute !== 'No Routes Available' && selectedRoute !== undefined && selectedRoute !== null;
    const isAircraftValid = selectedAircraft !== 'No Aircraft Available' && selectedAircraft !== undefined && selectedAircraft !== null;
    if (checked && (!isRouteValid || !isAircraftValid)) {
      dispatch(newNotification({
        variant: 'error',
        message: 'Please ensure all options are correctly selected.'
      }));
      return;
    }
    setChecked(checked);
    setOpenDialog(true);
    setMenuOpen(true);
    setSelectedFlightCard(flightCard);
  };

  function onClose() {
    setOpenDialog(false);
  }

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCells())
    refreshFlightCards();
    getAircraft().then(res => {
      const aircraftArray = filterAircraft(res);
      const sortedAircraft = aircraftArray.sort();
      setFilteredAircraft(sortedAircraft);
    })
    getAllRoutes().then(res => {
      setAllAdresses(res);
    })
    updateMapSize();
    window.addEventListener('resize', updateMapSize);

    const apiPollIntervalInSeconds = 60;
    const interval = setInterval(() => {
      refreshFlightCards();
    }, apiPollIntervalInSeconds*1000);
    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', updateMapSize);
    };
  }, []);

  const refreshFlightCards = () => {
    getFlightCards().then(res => {
      setLatestFlightCards(res);
    })
  }

  useEffect(() => {
    updateRoutesState(allAdresses);
  }, [allAdresses])

  useEffect(() => {
    if (cells !== undefined && cells.length > 0) {
        const sorted = [...cells].sort((a, b) => a.cellName.localeCompare(b.cellName));
        setSortedCells(sorted);
        setSelectedCell(sorted.find(cell => cell.cellName === 'BELAIR'));
    }
  }, [cells]);

  useEffect(() => {
    let addressesInCell;
    if (selectedCell === null) {
      addressesInCell = allAdresses.filter(address => address.cellId === null);
    } else {
      addressesInCell = allAdresses.filter(address => address.cellId === selectedCell.id);
    }
    updateRoutesState(addressesInCell);
    resetStates();
  }, [selectedCell, allAdresses]);

  useEffect(() => {
    const selectedCellId = selectedCell === null ? null : selectedCell.id;
    const filteredFlightCards = latestFlightCards?.filter(flightCard =>
      allAdresses.some(address =>
        flightCard.orderId === address.orderId && address.cellId === selectedCellId
      )
    );
    setFilteredFlightCards(filteredFlightCards);
  }, [latestFlightCards, allAdresses, selectedCell]);

  const resetStates = () => {
    setSelectedRoute(null);
    setSelectedAddress(null);
    setSelectedAircraft(null);
    setIsConflict(false);
    setIsBlockConflictName(false);
  }
  useEffect(() => {
    setRouteLength(0);
    setRouteTooLow(false);
    setRouteSloped(false);
    const address = allAdresses.find(address => address.eircode === selectedRoute);
    setSelectedAddress(address);
  }, [selectedRoute]);

  const updateRoutesState = (addressList) => {
    const routeArray = removeDuplicateRoutes(addressList);
    const sortedRoutes = routeArray.sort()
    setRoutes(sortedRoutes);
  }

  const handleRouteLengthChange = (length) => {
    setRouteLength(length);
  };

  const handleRouteTooLowChange = (isTooLow) => {
    setRouteTooLow(isTooLow);
  };

  const handleRouteSlopedChange = (isSloped) => {
    setRouteSloped(isSloped);
  };

  const removeDuplicateRoutes = flightCards => {
    const filteredArray = [];
    flightCards.forEach(address => {
      if (filteredArray.includes(address.eircode) !== true) {
        filteredArray.push(address.eircode);
      }
    });
    return filteredArray;
  };

  const filterAircraft = (aircraftObjects) => {
    let filteredAircraft = [];
    aircraftObjects.forEach(obj => {
      const aircraft = obj.assetName.replace('MNA-', '');
      if (aircraft != 'BOM') {
        filteredAircraft.push(aircraft);
      }
    });
    return filteredAircraft;
  };

  const handleClose = () => {
    if (menuOpen === true) {
      setOpenDialog(false);
      setSelectedFlightCard(null);
      setMenuOpen(false);
    }
    refreshFlightCards();
  };

  const handleAircraftUpdate = (aircraft) => {
    setSelectedAircraft(aircraft);
  };

  const handleCellSelect = (cellName) => {
    if (cellName === 'no-associated-cell') {
      setSelectedCell(null);
    } else {
      const selected = cells.find(cell => cell.cellName === cellName) || { cellName: 'No Cells Available' };
      setSelectedCell(selected);
    }
  };

  const handleRouteSelect = (route) => {
    setSelectedRoute(route);
  };

  const updateMapSize = () => {
    if (mapRef.current) {
      setMapHeight(mapRef.current.clientHeight);
      setMapWidth(mapRef.current.clientWidth);
    }
  };

  const generateRouteWarning = () => {
    const warnings = [];
    if (routeLength > maxRecommendedDistance) {
      warnings.push(`The selected route is longer than ${maxRecommendedDistance}km. (${routeLength.toFixed(1)}km)`);
    }
    if (routeSloped) {
      warnings.push("The selected route is sloped.");
    }
    if (routeTooLow) {
      warnings.push(`The selected route flies below ${maxRecommendedAltitude}m.`);
    }
    if (warnings.length > 0) {
      return (
        <div>
          <h3 className={'text-lg font-semibold'} style={{ marginTop: '20px', color: 'rgb(255, 190, 0)' }}>
            Warning:
          </h3>
          <Box component="ul" sx={{ listStyleType: 'disc', marginLeft: '20px', color: 'rgb(255, 190, 0)' }}>
            {warnings.map((warning, index) => (
              <Box component="li" key={index}>
                <Typography variant='h4' style={{ marginTop: '20px', color: 'rgb(255, 190, 0)' }}>{warning}</Typography>
              </Box>
            ))}
          </Box>
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div
      style={{ display: 'flex', flexDirection: 'row', overflow: 'hidden', padding: 0, backgroundColor: 'white', height: '100%' }}
      onClick={() => handleClose()}
    >
      <div style={{ flex: 1, minWidth: '400px', padding: 10 }}>
        <ActivateFlightCardRouteDialog
          modalOpen={openDialog}
          onClose={onClose}
          flightCard={selectedFlightCard}
          address={selectedAddress}
          aircraft={selectedAircraft}
          handleClose={handleClose}
          udpateFlightCardActive={udpateFlightCardActive}
          addFlightCard={addFlightCard}
          checked={checked}
        />

        <FormControl fullWidth style={{ width: 400, marginRight: 32 }}>
          <FilteredDropdown
            label={'Cell: '}
            onChange={(newCell) => handleCellSelect(newCell)}
            options={[
              { value: 'no-associated-cell', displayText: 'NO ASSOCIATED CELL' },
              ...(sortedCells?.length > 0
                ? sortedCells.map(cell => ({
                    value: cell.cellName,
                    displayText: cell.cellName
                  }))
                : [{ value: 'No Cells Available', displayText: 'No Cells Available' }])
            ]}
            value={selectedCell === null ? 'no-associated-cell' : selectedCell.cellName}
          />
        </FormControl>

        <div style={{ margin: 16 }}>
          <h3 className={'text-lg font-semibold text-gray-800'}>ACTIVE LIST</h3>
        </div>

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 400 }} aria-label="assets table">
            <TableHead>
              <TableRow>
                <TableCell>
                  <h3 className={'text-lg font-semibold text-gray-800'}>Route</h3>
                </TableCell>
                <TableCell>
                  <h3 className={'text-lg font-semibold text-gray-800'}>Aircraft</h3>
                </TableCell>
                <TableCell>
                  <h3 className={'text-lg font-semibold text-gray-800'}>Active</h3>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredFlightCards
                ?.filter(flightCard => flightCard.active)
                ?.map((flightCard: FlightCard, index: number) => (
                  <TableRow
                    key={flightCard.id}
                    sx={{
                      '&:last-child td, &:last-child th': { border: 0 },
                      backgroundColor:
                        flightCard.active === true ? '#f0fdf4' : '#FFFFFF',
                      height: 112
                    }}>
                    <TableCell>
                      <h3 className={'text-lg font-semibold text-gray-800'}>{flightCard.route}</h3>
                    </TableCell>
                    <TableCell>
                      <h3 className={'text-lg font-semibold text-gray-800'}>{flightCard.aircraft}</h3>
                    </TableCell>
                    <TableCell>
                      <FormControlLabel
                        label={<h3 className={'text-lg font-semibold text-gray-800'}>Active</h3>}
                        control={
                          <Switch
                            checked={flightCard.active}
                            onChange={(_, checked) => {
                              handleActiveFlightCard(flightCard, checked);
                            }}
                            color="primary"
                          />
                        }
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div style={{ marginBottom: 12 }}>
          <div style={{ margin: 16 }}>
            <h3 className={'text-lg font-semibold text-gray-800'}>Create New Flight Card</h3>
          </div>
        </div>
        <TableContainer style={{ overflow: 'visible' }} component={Paper}>
          <Table sx={{ minWidth: 400 }} aria-label="assets table">
            <TableBody>
              <TableRow>
                <TableCell>
                  <FormControl fullWidth style={{ minWidth: 250, marginRight: 10 }}>
                    <FilteredDropdown
                      label={'Route: '}
                      onChange={(newRoute) => handleRouteSelect(newRoute)}
                      options={
                        (routes.length > 0 ? [...routes] : ['No Routes Available'])
                        .map(route => {
                          return {
                            value: route,
                            displayText: route
                          };
                        })
                      }
                      value={selectedRoute === null ? 'No Routes Available' : selectedRoute}
                    />
                  </FormControl>
                </TableCell>
                <TableCell>
                  <FormControl fullWidth style={{ minWidth: 80, marginRight: 10 }}>
                    <FilteredDropdown
                      label={'Aircraft: '}
                      onChange={(newAircraft) => handleAircraftUpdate(newAircraft)}
                      options={
                        (filteredAircraft.length > 0 ? [...filteredAircraft] : ['No Aircraft Available'])
                        .map(aircraft => {
                          return {
                            value: aircraft,
                            displayText: aircraft
                          };
                        })
                      }
                      value={selectedAircraft === null ? 'No Aircraft Available' : selectedAircraft}
                    />
                  </FormControl>
                </TableCell>
                <TableCell>
                  <Button
                    sx={{
                      marginRight: 6,
                      height: 50,
                      width: 120
                    }}
                    variant="contained"
                    type="button"
                    color="primary"
                    onClick={() => handleActiveFlightCard(selectedFlightCard, true)}
                    disabled={isBlockConflictName && isConflict}
                  >
                    <h3 className={'text-lg font-semibold text-white'}>
                      Activate
                    </h3>
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {generateRouteWarning()}
      </div>

      <div style={{ flex: 1, height: '100vh' }} ref={mapRef}>
        <FlightCardMap
          onConflictChange={(hasConflict) => setIsConflict(hasConflict)}
          onBlockConflictNameChange={(hasBlockConflict) => setIsBlockConflictName(hasBlockConflict)}
          selectedAddress={selectedAddress}
          selectedAircraft={selectedAircraft}
          selectedCell={selectedCell}
          filteredFlightCards={filteredFlightCards}
          allAdresses={allAdresses}
          componentHeight={mapHeight}
          componentWidth={mapWidth}
          onRouteLengthChange={handleRouteLengthChange}
          onRouteTooLowChange={handleRouteTooLowChange}
          onRouteSlopedChange={handleRouteSlopedChange}
          maxRecommendedAltitude={maxRecommendedAltitude}
          maxRecommendedDistance={maxRecommendedDistance}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  flightCards: state.flightCards.flightCards
});

const mapDispatchToProps = dispatch => ({
  getFlightCards: () => dispatch(getFlightCards()),
  getAllRoutes: () => dispatch(getAllRoutes()),
  getAircraft: () => dispatch(getAircraft()),
  udpateFlightCardActive: (id: string, isActive: boolean) =>
    dispatch(udpateFlightCardActive(id, isActive)),
  addFlightCard: (flightCard: FlightCard) => dispatch(addFlightCard(flightCard)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewFlightCards);
